(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-in-stock"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('back-in-stock')) {
    customElements.define('back-in-stock', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="email"]');
        this.status = this.querySelector('.back-in-stock__status');

        this.form.addEventListener('submit', (event) => this.onSubmit(event), { signal });
        document.addEventListener('variant:change', (event) => this.onVariantChange(event), { signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      onVariantChange(event) {
        if (event.detail?.formId !== this.getAttribute('form-id')) return;
        const variant = event.detail.variant;
        this.hidden = !variant || variant.available;
        if (!variant) return;

        // A different variant needs its own subscription, so reset any previous confirmation.
        if (String(variant.id) !== this.dataset.variantId) {
          this.dataset.variantId = variant.id;
          this.removeAttribute('data-state');
          this.status.hidden = true;
        }
      }

      showStatus(message, state) {
        this.status.textContent = message;
        this.status.hidden = false;
        this.dataset.state = state;
      }

      async onSubmit(event) {
        event.preventDefault();
        const email = this.input.value.trim();

        if (!this.input.checkValidity() || !email) {
          this.showStatus(this.dataset.invalid, 'error');
          this.input.focus();
          return;
        }

        const button = this.form.querySelector('button');
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(this.dataset.companyId)}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
            body: JSON.stringify({
              data: {
                type: 'back-in-stock-subscription',
                attributes: {
                  profile: { data: { type: 'profile', attributes: { email } } },
                  channels: ['EMAIL']
                },
                relationships: {
                  variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.dataset.variantId}` } }
                }
              }
            })
          });

          if (!response.ok) throw new Error(`Klaviyo responded ${response.status}`);
          this.showStatus(this.dataset.success, 'success');
        } catch (error) {
          console.error('[Back in stock]', error);
          this.showStatus(this.dataset.error, 'error');
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-promise')) {
    customElements.define('delivery-promise', class extends HTMLElement {
      connectedCallback() {
        const countryCode = this.dataset.countryCode?.trim().toUpperCase();
        const flag = this.querySelector('[data-delivery-flag]');

        if (flag && countryCode?.length === 2) {
          flag.textContent = String.fromCodePoint(...Array.from(countryCode, letter => 127397 + letter.charCodeAt(0)));
        }

        if (this.querySelector('[data-delivery-date]')?.dataset.preorder === 'true') {
          return;
        }

        const dispatchDays = Math.max(0, Number.parseInt(this.dataset.dispatchBusinessDays, 10) || 0);
        const shipDate = this.addBusinessDays(new Date(), dispatchDays);
        const formattedDate = new Intl.DateTimeFormat(this.dataset.locale || undefined, {
          weekday: 'short',
          month: 'short',
          day: 'numeric'
        }).format(shipDate);
        const dateElement = this.querySelector('[data-delivery-date]');

        if (dateElement) {
          dateElement.textContent = this.dataset.dateTemplate.replace('__DATE__', formattedDate);
        }
      }

      addBusinessDays(date, days) {
        const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        let remainingDays = days;

        if (remainingDays === 0) {
          while (result.getDay() === 0 || result.getDay() === 6) {
            result.setDate(result.getDate() + 1);
          }
        }

        while (remainingDays > 0) {
          result.setDate(result.getDate() + 1);

          if (result.getDay() !== 0 && result.getDay() !== 6) {
            remainingDays -= 1;
          }
        }

        return result;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
